import {validateField, submitFields, clearFields, setFieldOptions, setFieldRequired, setCheckBoxValue, setTeaxtareaValue} from './helpers/form'
import {
  FETCH_SKILLVENDOR_EDIT_DATA_SUCCESS,
  VALIDATE_SKILLVENDOR_EDIT_FIELD,
  SUBMIT_SKILLVENDOR_EDIT_FIELDS,
  CLEAR_SKILLVENDOR_EDIT_FIELDS
} from '../../../actions/pages/skillvendor-page'


export function skillVendorEdit(
  state = {
    valid: false,
    fields: [
      {
        name: 'KnownTalent',
        value: false,
        type: 'checkbox',
        rules: {
          title: 'Known talent'
        }
      },
      {
        name: 'DoNotUse',
        value: false,
        type: 'checkbox',
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'DoNotUseReason',
        value: '',
        errors: [],
        placeholder: ' ',
        rules: {
          title: 'Reason',
          required: true
        },
        options: [],
        isNullable: true
      },
      {
        name: 'DoNotUseComment',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Comment'
        }
      },
      {
        name: 'Note',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Note'
        }
      },
      {
        name: 'DoNotUseAdaptor',
        value: false,
        type: 'checkbox',
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'DoNotUseReasonAdaptor',
        value: '',
        errors: [],
        placeholder: ' ',
        rules: {
          title: 'Reason'
        },
        options: [],
        isNullable: true
      },
      {
        name: 'DoNotUseCommentAdaptor',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Comment'
        }
      },
      {
        name: 'DoNotUseDirector',
        value: false,
        type: 'checkbox',
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'DoNotUseReasonDirector',
        value: '',
        errors: [],
        placeholder: ' ',
        rules: {
          title: 'Reason'
        },
        options: [],
        isNullable: true
      },
      {
        name: 'DoNotUseCommentDirector',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Comment'
        }
      },
      {
        name: 'DoNotUseTranslator',
        value: false,
        type: 'checkbox',
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'DoNotUseReasonTranslator',
        value: '',
        errors: [],
        placeholder: ' ',
        rules: {
          title: 'Reason'
        },
        options: [],
        isNullable: true
      },
      {
        name: 'DoNotUseCommentTranslator',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Comment'
        }
      },
      {
        name: 'DoNotUseSinger',
        value: false,
        type: 'checkbox',
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'DoNotUseReasonSinger',
        value: '',
        errors: [],
        placeholder: ' ',
        rules: {
          title: 'Reason'
        },
        options: [],
        isNullable: true
      },
      {
        name: 'DoNotUseCommentSinger',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Comment'
        }
      },
      {
        name: 'DoNotUseActor',
        value: false,
        type: 'checkbox',
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'DoNotUseReasonActor',
        value: '',
        errors: [],
        placeholder: ' ',
        rules: {
          title: 'Reason'
        },
        options: [],
        isNullable: true
      },
      {
        name: 'DoNotUseCommentActor',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Comment'
        }
      },
      {
        name: 'DoNotUseLyricist',
        value: false,
        type: 'checkbox',
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'DoNotUseReasonLyricist',
        value: '',
        errors: [],
        placeholder: ' ',
        rules: {
          title: 'Reason'
        },
        options: [],
        isNullable: true
      },
      {
        name: 'DoNotUseCommentLyricist',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Comment'
        }
      },
      {
        name: 'DoNotUseEditor',
        value: false,
        type: 'checkbox',
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'DoNotUseReasonEditor',
        value: '',
        errors: [],
        placeholder: ' ',
        rules: {
          title: 'Reason'
        },
        options: [],
        isNullable: true
      },
      {
        name: 'DoNotUseCommentEditor',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Comment'
        }
      },
      {
        name: 'DoNotUseSoundEngineer',
        value: false,
        type: 'checkbox',
        rules: {
          title: 'Do not use'
        }
      },
      {
        name: 'DoNotUseReasonSoundEngineer',
        value: '',
        errors: [],
        placeholder: ' ',
        rules: {
          title: 'Reason'
        },
        options: [],
        isNullable: true
      },
      {
        name: 'DoNotUseCommentSoundEngineer',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Comment'
        }
      }
    ]
  },
  action
) {
  switch (action.type) {
    case FETCH_SKILLVENDOR_EDIT_DATA_SUCCESS: {
      let fields = state.fields.map((field) => {
        let newValue;
        Object.entries(action.data).forEach(([key, value]) => {
          if (field.name === key){
            newValue = value;
            return;
          }
        })

        if (newValue !== undefined) {
          return {
            ...field,
            value: newValue,
            errors: []
          }
        }
        return field;
      })

      var newState = Object.assign({}, state, {
        valid: true,
        fields: Array.from(fields)
      })

      action.data.Profiles.map((profile) => {
        if(profile.ProfileTypeLabel == 'Adaptor'){
          var doNotUseAdaptor = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Adaptor').DoNotUse;
          var doNotUseCommentAdaptor = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Adaptor').DoNotUseComment;
          var doNotUseReasonAdaptor = {Items: [], SelectedValue: action.data.Profiles.find(f => f.ProfileTypeLabel == 'Adaptor').DoNotUseReason};
          doNotUseReasonAdaptor.Items = [
            {value: 'Competitor', label: 'Competitor'},
            {value: 'TestAccount', label: 'Test account'},
            {value: 'NotReliable', label: 'Unreliable'},
            {value: 'NotEligible', label: 'Not eligible'}
          ]
          newState = setCheckBoxValue(newState, 'DoNotUseAdaptor', doNotUseAdaptor);
          newState = setFieldOptions(newState, 'DoNotUseReasonAdaptor', doNotUseReasonAdaptor);
          newState = setTeaxtareaValue(newState, 'DoNotUseCommentAdaptor', doNotUseCommentAdaptor);
          newState = onDoNotUseAdaptorChanged(newState);
        }
        if(profile.ProfileTypeLabel == 'Director'){
          var doNotUseDirector = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Director').DoNotUse;
          var doNotUseCommentDirector = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Director').DoNotUseComment;
          var doNotUseReasonDirector = {Items: [], SelectedValue: action.data.Profiles.find(f => f.ProfileTypeLabel == 'Director').DoNotUseReason};
          doNotUseReasonDirector.Items = [
            {value: 'Competitor', label: 'Competitor'},
            {value: 'TestAccount', label: 'Test account'},
            {value: 'NotReliable', label: 'Unreliable'},
            {value: 'NotEligible', label: 'Not eligible'}
          ]
          newState = setCheckBoxValue(newState, 'DoNotUseDirector', doNotUseDirector);
          newState = setFieldOptions(newState, 'DoNotUseReasonDirector', doNotUseReasonDirector);
          newState = setTeaxtareaValue(newState, 'DoNotUseCommentDirector', doNotUseCommentDirector);
          newState = onDoNotUseDirectorChanged(newState);
        }
        if(profile.ProfileTypeLabel == 'Translator'){
          var doNotUseTranslator = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Translator').DoNotUse;
          var doNotUseCommentTranslator = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Translator').DoNotUseComment;
          var doNotUseReasonTranslator = {Items: [], SelectedValue: action.data.Profiles.find(f => f.ProfileTypeLabel == 'Translator').DoNotUseReason};
          doNotUseReasonTranslator.Items = [
            {value: 'Competitor', label: 'Competitor'},
            {value: 'TestAccount', label: 'Test account'},
            {value: 'NotReliable', label: 'Unreliable'},
            {value: 'NotEligible', label: 'Not eligible'}
          ]
          newState = setCheckBoxValue(newState, 'DoNotUseTranslator', doNotUseTranslator);
          newState = setFieldOptions(newState, 'DoNotUseReasonTranslator', doNotUseReasonTranslator);
          newState = setTeaxtareaValue(newState, 'DoNotUseCommentTranslator', doNotUseCommentTranslator);
          newState = onDoNotUseTranslatorChanged(newState);
        }
        if(profile.ProfileTypeLabel == 'Singer'){
          var doNotUseSinger = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Singer').DoNotUse;
          var doNotUseCommentSinger = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Singer').DoNotUseComment;
          var doNotUseReasonSinger = {Items: [], SelectedValue: action.data.Profiles.find(f => f.ProfileTypeLabel == 'Singer').DoNotUseReason};
          doNotUseReasonSinger.Items = [
            {value: 'Competitor', label: 'Competitor'},
            {value: 'TestAccount', label: 'Test account'},
            {value: 'NotReliable', label: 'Unreliable'},
            {value: 'NotEligible', label: 'Not eligible'}
          ]
          newState = setCheckBoxValue(newState, 'DoNotUseSinger', doNotUseSinger);
          newState = setFieldOptions(newState, 'DoNotUseReasonSinger', doNotUseReasonSinger);
          newState = setTeaxtareaValue(newState, 'DoNotUseCommentSinger', doNotUseCommentSinger);
          newState = onDoNotUseSingerChanged(newState);
        }
        if(profile.ProfileTypeLabel == 'Actor'){
          var doNotUseActor = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Actor').DoNotUse;
          var doNotUseCommentActor = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Actor').DoNotUseComment;
          var doNotUseReasonActor = {Items: [], SelectedValue: action.data.Profiles.find(f => f.ProfileTypeLabel == 'Actor').DoNotUseReason};
          doNotUseReasonActor.Items = [
            {value: 'Competitor', label: 'Competitor'},
            {value: 'TestAccount', label: 'Test account'},
            {value: 'NotReliable', label: 'Unreliable'},
            {value: 'NotEligible', label: 'Not eligible'}
          ]
          newState = setCheckBoxValue(newState, 'DoNotUseActor', doNotUseActor);
          newState = setFieldOptions(newState, 'DoNotUseReasonActor', doNotUseReasonActor);
          newState = setTeaxtareaValue(newState, 'DoNotUseCommentActor', doNotUseCommentActor);
          newState = onDoNotUseActorChanged(newState);
        }
        if(profile.ProfileTypeLabel == 'Lyricist'){
          var doNotUseLyricist = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Lyricist').DoNotUse;
          var doNotUseCommentLyricist = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Lyricist').DoNotUseComment;
          var doNotUseReasonLyricist = {Items: [], SelectedValue: action.data.Profiles.find(f => f.ProfileTypeLabel == 'Lyricist').DoNotUseReason};
          doNotUseReasonLyricist.Items = [
            {value: 'Competitor', label: 'Competitor'},
            {value: 'TestAccount', label: 'Test account'},
            {value: 'NotReliable', label: 'Unreliable'},
            {value: 'NotEligible', label: 'Not eligible'}
          ]
          newState = setCheckBoxValue(newState, 'DoNotUseLyricist', doNotUseLyricist);
          newState = setFieldOptions(newState, 'DoNotUseReasonLyricist', doNotUseReasonLyricist);
          newState = setTeaxtareaValue(newState, 'DoNotUseCommentLyricist', doNotUseCommentLyricist);
          newState = onDoNotUseLyricistChanged(newState);
        }
        if(profile.ProfileTypeLabel == 'Editor'){
          var doNotUseEditor = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Editor').DoNotUse;
          var doNotUseCommentEditor = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Editor').DoNotUseComment;
          var doNotUseReasonEditor = {Items: [], SelectedValue: action.data.Profiles.find(f => f.ProfileTypeLabel == 'Editor').DoNotUseReason};
          doNotUseReasonEditor.Items = [
            {value: 'Competitor', label: 'Competitor'},
            {value: 'TestAccount', label: 'Test account'},
            {value: 'NotReliable', label: 'Unreliable'},
            {value: 'NotEligible', label: 'Not eligible'}
          ]
          newState = setCheckBoxValue(newState, 'DoNotUseEditor', doNotUseEditor);
          newState = setFieldOptions(newState, 'DoNotUseReasonEditor', doNotUseReasonEditor);
          newState = setTeaxtareaValue(newState, 'DoNotUseCommentEditor', doNotUseCommentEditor);
          newState = onDoNotUseEditorChanged(newState);
        }
        if(profile.ProfileTypeLabel == 'Sound Engineer'){
          var doNotUseSoundEngineer = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Sound Engineer').DoNotUse;
          var doNotUseCommentSoundEngineer = action.data.Profiles.find(f => f.ProfileTypeLabel == 'Sound Engineer').DoNotUseComment;
          var doNotUseReasonSoundEngineer = {Items: [], SelectedValue: action.data.Profiles.find(f => f.ProfileTypeLabel == 'Sound Engineer').DoNotUseReason};
          doNotUseReasonSoundEngineer.Items = [
            {value: 'Competitor', label: 'Competitor'},
            {value: 'TestAccount', label: 'Test account'},
            {value: 'NotReliable', label: 'Unreliable'},
            {value: 'NotEligible', label: 'Not eligible'}
          ]
          newState = setCheckBoxValue(newState, 'DoNotUseSoundEngineer', doNotUseSoundEngineer);
          newState = setFieldOptions(newState, 'DoNotUseReasonSoundEngineer', doNotUseReasonSoundEngineer);
          newState = setTeaxtareaValue(newState, 'DoNotUseCommentSoundEngineer', doNotUseCommentSoundEngineer);
          newState = onDoNotUseSoundEngineerChanged(newState);
        }
      });

      newState = setFieldOptions(newState, 'DoNotUseReason', action.data.DoNotUseReasons);
      newState = setFieldOptions(newState, 'ProductionContentOwner', action.data.ProductionContentOwners);
      newState = onDoNotUseChanged(newState);



      return newState;
    }

    case VALIDATE_SKILLVENDOR_EDIT_FIELD: {
      let newState = validateField(state, action);

      if (action.field.name === 'DoNotUse') {
        newState = onDoNotUseChanged(newState);
      }

      if (action.field.name === 'DoNotUseAdaptor') {
        newState = onDoNotUseAdaptorChanged(newState);
      }

      if (action.field.name === 'DoNotUseDirector') {
        newState = onDoNotUseDirectorChanged(newState);
      }

      if (action.field.name === 'DoNotUseTranslator') {
        newState = onDoNotUseTranslatorChanged(newState);
      }

      if (action.field.name === 'DoNotUseSinger') {
        newState = onDoNotUseSingerChanged(newState);
      }

      if (action.field.name === 'DoNotUseActor') {
        newState = onDoNotUseActorChanged(newState);
      }

      if (action.field.name === 'DoNotUseLyricist') {
        newState = onDoNotUseLyricistChanged(newState);
      }

      if (action.field.name === 'DoNotUseEditor') {
        newState = onDoNotUseEditorChanged(newState);
      }

      if (action.field.name === 'DoNotUseSoundEngineer') {
        newState = onDoNotUseSoundEngineerChanged(newState);
      }

      return newState;
    }

    case SUBMIT_SKILLVENDOR_EDIT_FIELDS:
      return submitFields(state, action);

    case CLEAR_SKILLVENDOR_EDIT_FIELDS:
      return clearFields(state);

    default:
      return state
  }
}

function onDoNotUseChanged(state) {
  var doNotUseField = state.fields.find((el) => {
    return el.name === 'DoNotUse';
  });

  var doNotUseChecked = doNotUseField.value === true;

  let fields = state.fields.map(item => {
    if (item.name === 'DoNotUseReason') {
      let newItem = setFieldRequired(item, doNotUseChecked);

      newItem.disabled = !doNotUseChecked;

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else if (item.name === 'DoNotUseComment') {
      let newItem = Object.assign({}, item, {
        disabled: !doNotUseChecked,
      })

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else {
      return item
    }
  })

  return Object.assign({}, state, {
    fields: Array.from(fields)
  })
}

function onDoNotUseDirectorChanged(state) {
  var doNotUseField = state.fields.find((el) => {
    return el.name === 'DoNotUseDirector';
  });

  var doNotUseChecked = doNotUseField.value === true;

  let fields = state.fields.map(item => {
    if (item.name === 'DoNotUseReasonDirector') {
      let newItem = setFieldRequired(item, doNotUseChecked);

      newItem.disabled = !doNotUseChecked;

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else if (item.name === 'DoNotUseCommentDirector') {
      let newItem = Object.assign({}, item, {
        disabled: !doNotUseChecked,
      })

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else {
      return item
    }
  })

  return Object.assign({}, state, {
    fields: Array.from(fields)
  })
}

function onDoNotUseTranslatorChanged(state) {
  var doNotUseField = state.fields.find((el) => {
    return el.name === 'DoNotUseTranslator';
  });

  var doNotUseChecked = doNotUseField.value === true;

  let fields = state.fields.map(item => {
    if (item.name === 'DoNotUseReasonTranslator') {
      let newItem = setFieldRequired(item, doNotUseChecked);

      newItem.disabled = !doNotUseChecked;

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else if (item.name === 'DoNotUseCommentTranslator') {
      let newItem = Object.assign({}, item, {
        disabled: !doNotUseChecked,
      })

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else {
      return item
    }
  })

  return Object.assign({}, state, {
    fields: Array.from(fields)
  })
}

function onDoNotUseAdaptorChanged(state) {
  var doNotUseField = state.fields.find((el) => {
    return el.name === 'DoNotUseAdaptor';
  });

  var doNotUseChecked = doNotUseField.value === true;

  let fields = state.fields.map(item => {
    if (item.name === 'DoNotUseReasonAdaptor') {
      let newItem = setFieldRequired(item, doNotUseChecked);

      newItem.disabled = !doNotUseChecked;

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else if (item.name === 'DoNotUseCommentAdaptor') {
      let newItem = Object.assign({}, item, {
        disabled: !doNotUseChecked,
      })

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else {
      return item
    }
  })

  return Object.assign({}, state, {
    fields: Array.from(fields)
  })
}

function onDoNotUseSingerChanged(state) {
  var doNotUseField = state.fields.find((el) => {
    return el.name === 'DoNotUseSinger';
  });

  var doNotUseChecked = doNotUseField.value === true;

  let fields = state.fields.map(item => {
    if (item.name === 'DoNotUseReasonSinger') {
      let newItem = setFieldRequired(item, doNotUseChecked);

      newItem.disabled = !doNotUseChecked;

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else if (item.name === 'DoNotUseCommentSinger') {
      let newItem = Object.assign({}, item, {
        disabled: !doNotUseChecked,
      })

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else {
      return item
    }
  })

  return Object.assign({}, state, {
    fields: Array.from(fields)
  })
}

function onDoNotUseActorChanged(state) {
  var doNotUseField = state.fields.find((el) => {
    return el.name === 'DoNotUseActor';
  });

  var doNotUseChecked = doNotUseField.value === true;

  let fields = state.fields.map(item => {
    if (item.name === 'DoNotUseReasonActor') {
      let newItem = setFieldRequired(item, doNotUseChecked);

      newItem.disabled = !doNotUseChecked;

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else if (item.name === 'DoNotUseCommentActor') {
      let newItem = Object.assign({}, item, {
        disabled: !doNotUseChecked,
      })

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else {
      return item
    }
  })

  return Object.assign({}, state, {
    fields: Array.from(fields)
  })
}

function onDoNotUseLyricistChanged(state) {
  var doNotUseField = state.fields.find((el) => {
    return el.name === 'DoNotUseLyricist';
  });

  var doNotUseChecked = doNotUseField.value === true;

  let fields = state.fields.map(item => {
    if (item.name === 'DoNotUseReasonLyricist') {
      let newItem = setFieldRequired(item, doNotUseChecked);

      newItem.disabled = !doNotUseChecked;

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else if (item.name === 'DoNotUseCommentLyricist') {
      let newItem = Object.assign({}, item, {
        disabled: !doNotUseChecked,
      })

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else {
      return item
    }
  })

  return Object.assign({}, state, {
    fields: Array.from(fields)
  })
}

function onDoNotUseEditorChanged(state) {
  var doNotUseField = state.fields.find((el) => {
    return el.name === 'DoNotUseEditor';
  });

  var doNotUseChecked = doNotUseField.value === true;

  let fields = state.fields.map(item => {
    if (item.name === 'DoNotUseReasonEditor') {
      let newItem = setFieldRequired(item, doNotUseChecked);

      newItem.disabled = !doNotUseChecked;

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else if (item.name === 'DoNotUseCommentEditor') {
      let newItem = Object.assign({}, item, {
        disabled: !doNotUseChecked,
      })

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else {
      return item
    }
  })

  return Object.assign({}, state, {
    fields: Array.from(fields)
  })
}

function onDoNotUseSoundEngineerChanged(state) {
  var doNotUseField = state.fields.find((el) => {
    return el.name === 'DoNotUseSoundEngineer';
  });

  var doNotUseChecked = doNotUseField.value === true;

  let fields = state.fields.map(item => {
    if (item.name === 'DoNotUseReasonSoundEngineer') {
      let newItem = setFieldRequired(item, doNotUseChecked);

      newItem.disabled = !doNotUseChecked;

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else if (item.name === 'DoNotUseCommentSoundEngineer') {
      let newItem = Object.assign({}, item, {
        disabled: !doNotUseChecked,
      })

      if (!doNotUseChecked) {
        newItem.value = '';
      }

      return newItem;
    }
    else {
      return item
    }
  })

  return Object.assign({}, state, {
    fields: Array.from(fields)
  })
}
